import React from 'react';
import {UncontrolledTooltip} from "reactstrap";
import {FMessage} from "../../hoc/IntlComponents";

const SplitTestLabel = ({style, tooltipTargetId, delay, tooltipPlacement }) => (
  <span style={style} className={'split_test'} id={tooltipTargetId}>
    A/B
    <UncontrolledTooltip
      placement={tooltipPlacement ? tooltipPlacement : 'right'}
      delay={delay ? delay : 250}
      target={tooltipTargetId}
    >
      <FMessage id={'flows.table.split_test'} />
    </UncontrolledTooltip>
  </span>
);

export default SplitTestLabel;
